import { AppMetadata } from '../types';

export const getPublicApps = async (): Promise<AppMetadata[]> => {
  // We invoke this endpoint in the new transfer page and this functionality is deprecated now.
  // However, our users are still able to access this page at https://transfer.zapier.com/new to see a deprecated page banner.
  // We shouldn't make a request to this endpoint as it only makes an additional API request that is not needed.
  // We might use this endpoint in the future, but for now, we should just return an empty array.
  // I keep this comment here for future reference.

  // const { results } = await fetch<AppMetadataPage>(
  //   '/api/v4/implementations/?global=true&public_only=true'
  // );
  // return results;
  return [];
};

export default getPublicApps;
